import {Component, computed, EventEmitter, inject, Input, OnInit, Output, signal} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {TerraUtils} from 'src/app/shared/TerraUtils';
import {LpAssetMobileFilterComponent} from './lp-asset-mobile-filter.component';

export interface FilteringItem {
  id: number;
  name: string;
}

@Component({
  selector: 'terra-lp-asset-filter',
  templateUrl: './lp-asset-filter.component.html',
  styleUrls: ['./lp-asset-filter.component.scss'],
})
export class LpAssetFilterComponent implements OnInit {
  private readonly _bottomSheet = inject(MatBottomSheet);

  #items = [];
  #allSelected = {id: null, name: 'All Investing Entities'};

  @Output() onFilter: EventEmitter<Array<FilteringItem>> = new EventEmitter();

  @Input() set items(value: Array<FilteringItem>) {
    this.#items = [this.#allSelected, ...value];
  }

  get items() {
    return this.#items;
  }

  allFilters: boolean = true;
  selected = new FormControl([this.#allSelected]);

  get isMobile(): boolean {
    return TerraUtils.isMobileDevice();
  }


  searchFilterCtrl = new FormControl(null);

  showInactive = signal(false);
  searchValue = signal('');
  filtered = computed(() => this.items.filter((prop) => prop.name.toLowerCase().includes(this.searchValue())));

  ngOnInit() {
    this.selectAll();

    this.selected.valueChanges.subscribe((selected) => {
      const showAll = selected?.some((item) => item.id == null);
      const size = selected?.length;

      if (!showAll) {
        if (!size) {
          this.selectAll();
          return;
        }
      } else {
        if (!this.allFilters) {
          this.selectAll();
          return;
        } else {
          if (size === 1) {
            return;
          }

          this.allFilters = false;
          this.selected.setValue(
            [...selected.filter((item) => item !== this.#allSelected)],
            {emitEvent: false}
          );
        }
      }

      this.onFilter.emit(selected.filter((item) => item.id !== null));
    });

    this.searchFilterCtrl.valueChanges
    .subscribe((value) => {
      this.searchValue.set(value);
    });

  }

  opneFilerMenu() {
    const selected = this.selected.value;
    this._bottomSheet
      .open(LpAssetMobileFilterComponent, {
        data: {
          menu: this.items,
          selected,
          allSelected: this.#allSelected,
        },
      })
      .afterDismissed()
      .subscribe((selectedOption) => {
        if (selectedOption) {
          this.selected.setValue(selectedOption);
        }
      });
  } 

  private selectAll() {
    this.allFilters = true;
    this.selected.setValue([this.#allSelected], {emitEvent: false});

    this.onFilter.emit(this.#items);
  }
}
